export function findByPath(obj, path) {
    return path.split('.').reduce(function (result, field) { return result[field]; }, obj);
}
//# sourceMappingURL=utils.js.map